// UploadMoldura.jsx (corrigido para garantir envio válido do arquivo tipo File)
import React, { useState, useEffect } from 'react';
import * as S from './styles';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack, MdRefresh, MdDelete } from 'react-icons/md';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import BuscaRedes from '../../services/Marketdo/BuscaRedes';
import sendUpload from '../../services/Logo_Moldura/Upload';
import deleteMoldura from '../../services/Logo_Moldura/deleteMoldura';
import ImageViewer from '../../services/Logo_Moldura/ImageViewer';
import MoldurasGallery from '../../components/MoldurasGallery';

function UploadMoldura() {
  const [redes, setRedes] = useState([]);
  const [redeSelecionada, setRedeSelecionada] = useState('');
  const [idRede, setIdRede] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [nomeBaseArquivo, setNomeBaseArquivo] = useState('');
  const [nomeMoldura, setNomeMoldura] = useState('');
  const [descricaoMoldura, setDescricaoMoldura] = useState('');
  const [timestamp, setTimestamp] = useState(Date.now());
  const [refreshGallery, setRefreshGallery] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRedes = async () => {
      try {
        const buscaRedes = new BuscaRedes();
        await buscaRedes.loadRede();
        setRedes(buscaRedes.getResultadoRede());
      } catch (error) {
        console.error('Erro ao buscar redes:', error);
      }
    };
    fetchRedes();
  }, []);

  const handleSelectRede = (e) => {
    const selectedId = e.target.value;
    setRedeSelecionada(selectedId);

    const rede = redes.find((r) => r._id.$oid === selectedId);
    const idRedeSelecionada = rede ? rede._id.$oid : '';
    setIdRede(idRedeSelecionada);

    if (idRedeSelecionada) {
      const nomeBase = `moldura_${idRedeSelecionada}`;
      setNomeBaseArquivo(`${nomeBase}.png`);
      setNomeMoldura(`Moldura ${new Date().toLocaleDateString()}`);
      setTimestamp(Date.now());
      setRefreshGallery(prev => prev + 1);
    } else {
      setNomeBaseArquivo('');
      setNomeMoldura('');
      setDescricaoMoldura('');
    }
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file || !idRede) {
      alert("Arquivo ou ID da rede não definido.");
      return;
    }

    const img = new Image();
    img.onload = function () {
      if (img.width < 50 || img.height < 50) {
        alert("A imagem precisa ter pelo menos 50x50 pixels.");
        e.target.value = '';
        return;
      }
      if (file instanceof File) {
        setSelectedFile(file);
      } else {
        alert("Erro: o arquivo selecionado não é válido.");
      }
    };
    img.onerror = function () {
      alert("Erro ao carregar a imagem.");
      e.target.value = '';
    };
    img.src = URL.createObjectURL(file);
  };

  const handleUploadMoldura = async () => {
    if (!selectedFile || !(selectedFile instanceof File) || !idRede) {
      alert("Selecione uma imagem válida e uma rede.");
      return;
    }
    if (!nomeMoldura.trim()) {
      alert("Informe um nome para a moldura.");
      return;
    }
    try {
      const timestamp = Date.now();
      const nomeArquivo = `moldura_${idRede}_${timestamp}.png`;
      const formDataUpload = new FormData();

      console.log('Arquivo será enviado como:', selectedFile);
      formDataUpload.append('file', selectedFile);
      formDataUpload.append('id_rede', idRede);
      formDataUpload.append('tipo', 'moldura');
      formDataUpload.append('descricao', descricaoMoldura || nomeMoldura);
      formDataUpload.append('ativo', 'true');
      formDataUpload.append('nome_arquivo', nomeArquivo);

      for (let [k, v] of formDataUpload.entries()) {
        console.log(`${k}:`, v instanceof File ? v.name : v);
      }

      const response = await sendUpload(idRede, formDataUpload);
      const nomeArquivoServidor = response.filename || nomeArquivo;
      setNomeBaseArquivo(nomeArquivoServidor);
      setTimestamp(Date.now());
      setRefreshGallery(prev => prev + 1);
      setSelectedFile(null);
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
      setNomeMoldura('');
      setDescricaoMoldura('');
      alert('Moldura enviada com sucesso!');
    } catch (error) {
      console.error('Erro detalhado:', error);
      alert('Erro ao fazer upload da moldura: ' + (error.message || 'Erro desconhecido'));
    }
  };

  const handleSelectMoldura = (moldura) => {
    setNomeBaseArquivo(moldura.nome);
    setNomeMoldura(moldura.nomeMoldura || moldura.nome);
    setDescricaoMoldura(moldura.descricao || '');
    setTimestamp(Date.now());
  };

  const handleRefreshGallery = () => {
    setRefreshGallery(prev => prev + 1);
    setTimestamp(Date.now());
  };

  const handleDeleteMoldura = async (nomeArquivo) => {
    if (window.confirm('Tem certeza que deseja excluir esta moldura?')) {
      try {
        await deleteMoldura(idRede, nomeArquivo);
        setNomeBaseArquivo('');
        setNomeMoldura('');
        setDescricaoMoldura('');
        setRefreshGallery(prev => prev + 1);
        alert('Moldura excluída com sucesso!');
      } catch (error) {
        console.error('Erro ao excluir moldura:', error);
        alert(error.message || 'Erro ao excluir moldura');
      }
    }
  };

  return (
    <>
      <Header />
      <S.BackButton onClick={() => navigate('/Marketdo')}>
        <MdArrowBack style={{ marginRight: '8px', fontSize: '20px' }} />
        Voltar
      </S.BackButton>
      <S.ContainerUnico>
        <S.Coluna>
          <S.Title>Upload de Moldura</S.Title>
          <S.InputGroup>
            <S.Label>Selecione uma Rede:</S.Label>
            <S.Select value={redeSelecionada} onChange={handleSelectRede}>
              <option value="">Selecione...</option>
              {redes.map((rede) => (
                <option key={rede._id.$oid} value={rede._id.$oid}>
                  {rede.nome_fantasia}
                </option>
              ))}
            </S.Select>
          </S.InputGroup>

          {idRede && (
            <>
              <S.InputGroup>
                <S.Label>Nome da Moldura:</S.Label>
                <S.Input value={nomeMoldura} onChange={(e) => setNomeMoldura(e.target.value)} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Descrição:</S.Label>
                <S.TextArea value={descricaoMoldura} onChange={(e) => setDescricaoMoldura(e.target.value)} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Imagem:</S.Label>
                <S.Input type="file" accept="image/*" onChange={handleLogoChange} />
              </S.InputGroup>
              {selectedFile && (
                <S.Button type="button" onClick={handleUploadMoldura}>Enviar Moldura</S.Button>
              )}
            </>
          )}
        </S.Coluna>

        <S.Coluna>
          {nomeBaseArquivo && (
            <div>
              <S.PreviewTitle>
                <span>Visualização da Moldura:</span>
                <S.RefreshButton onClick={handleRefreshGallery}>
                  <MdRefresh />
                </S.RefreshButton>
              </S.PreviewTitle>
              <S.PreviewContainer>
                <ImageViewer 
                  nomeArquivo={nomeBaseArquivo} 
                  idRede={idRede} 
                  timestamp={timestamp}
                  key={`image-${timestamp}`}
                />
                <S.DeleteButton 
                  onClick={() => handleDeleteMoldura(nomeBaseArquivo)}
                  title="Excluir moldura"
                >
                  <MdDelete />
                </S.DeleteButton>
              </S.PreviewContainer>
            </div>
          )}
          {idRede && (
            <MoldurasGallery 
              idRede={idRede} 
              onSelectMoldura={handleSelectMoldura}
              onDeleteMoldura={handleDeleteMoldura}
              key={`gallery-${refreshGallery}`}
            />
          )}
        </S.Coluna>
      </S.ContainerUnico>
      <Footer />
    </>
  );
}

export default UploadMoldura;
